import {Dispatch, FC, SetStateAction} from 'react'
import {CustomInputs} from '../../../../../../_metronic/helpers/components/CustomInputs'

export const PROFORMA_TERMS_MAX_LENGTH = 1000

type Props = {
  issueDate: string
  validUntil: {value: string; setValue: Dispatch<SetStateAction<string>>}
  paymentTerms: {value: string; setValue: Dispatch<SetStateAction<string>>}
  deliveryTerms: {value: string; setValue: Dispatch<SetStateAction<string>>}
  defaultValidityDays?: number
}

/**
 * The fields only a proforma has. It is an offer: no tax ID, no send; it becomes an invoice through
 * «تبدیل به صورتحساب» in the list.
 */
const ProformaFormFields: FC<Props> = ({
  issueDate,
  validUntil,
  paymentTerms,
  deliveryTerms,
  defaultValidityDays,
}) => {
  const issueDay = (issueDate || '').slice(0, 10)

  return (
    <section className='mp-invoice-section mb-5' aria-labelledby='invoice-proforma-title'>
      <div className='alert alert-light-info d-flex align-items-start mb-5' role='note'>
        <i className='las la-file-signature fs-2 me-2 mt-1' aria-hidden='true'></i>
        <span>
          این سند <strong>پیش‌فاکتور</strong> است: شمارهٔ مالیاتی نمی‌گیرد و به سامانهٔ مؤدیان ارسال
          نمی‌شود. وقتی مشتری پذیرفت، از فهرست صورتحساب‌ها گزینهٔ «تبدیل به صورتحساب» را بزنید.
        </span>
      </div>
      <h3 id='invoice-proforma-title' className='fs-5 fw-bolder mb-4'>
        مشخصات پیش‌فاکتور
      </h3>
      <div className='row g-4'>
        <div className='col-12 col-md-6'>
          <CustomInputs
            type='datepicker'
            isRequired
            label='معتبر تا'
            hint={
              defaultValidityDays
                ? `پیش‌فرض این کسب‌وکار: ${defaultValidityDays} روز پس از تاریخ صدور`
                : 'پیش‌فاکتور تا پایان همین روز معتبر است.'
            }
            limitFromDate={issueDay || undefined}
            stateValue={validUntil}
          />
        </div>
        <div className='col-12'>
          <CustomInputs
            type='textarea'
            label='شرایط پرداخت'
            hint='مثلاً: ۵۰٪ پیش‌پرداخت، مانده هنگام تحویل (حداکثر ۱۰۰۰ نویسه)'
            textAreaRows={2}
            stateValue={paymentTerms}
          />
        </div>
        <div className='col-12'>
          <CustomInputs
            type='textarea'
            label='شرایط و زمان تحویل'
            hint='مثلاً: تحویل در محل خریدار، ۱۰ روز کاری پس از پرداخت (حداکثر ۱۰۰۰ نویسه)'
            textAreaRows={2}
            stateValue={deliveryTerms}
          />
        </div>
      </div>
    </section>
  )
}

export {ProformaFormFields}
